import React, { memo } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const BrowserMockCard = memo(({ children, className }) => {
    return (
        <div className={`browser-mock-card ${className || ''}`}>
            <div className="browser-mock-card__header">
                <div className="browser-mock-card__dots">
                    <span className="browser-mock-card__dot browser-mock-card__dot" />
                    <span className="browser-mock-card__dot browser-mock-card__dot" />
                    <span className="browser-mock-card__dot browser-mock-card__dot" />
                </div>
                <div className="browser-mock-card__address-bar" />
            </div>
            <div className="browser-mock-card__content">{children}</div>
        </div>
    );
});

BrowserMockCard.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

BrowserMockCard.displayName = 'BrowserMockCard';

export default BrowserMockCard;
